import { request } from "./http";

export interface TreasuryBalance {
  currency: string;
  balance: string;
}

export interface TreasuryAccount {
  id: string;
  label: string;
  bank_name: string | null;
  iban: string | null;
  bic: string | null;
  account_number: string | null;
  currency: string;
  is_segregated: boolean;
  status: string;
  balances: TreasuryBalance[];
  created_at: string | null;
}

export interface MarginCall {
  id: string;
  trading_account_id: string;
  action: "CALL" | "STOP_OUT";
  level_pct: string;
  equity: string;
  margin_used: string;
  free_margin: string;
  note: string | null;
  created_at: string | null;
}

export interface TreasuryAccountCreate {
  label: string;
  currency?: string;
  is_segregated?: boolean;
  bank_name?: string | null;
  iban?: string | null;
  bic?: string | null;
  account_number?: string | null;
}

export type TreasuryAccountPatch = Partial<
  TreasuryAccountCreate & { status: string }
>;

export const treasury = {
  list: () => request<TreasuryAccount[]>("/api/v1/admin/treasury"),
  create: (body: TreasuryAccountCreate) =>
    request<TreasuryAccount>("/api/v1/admin/treasury", { body }),
  patch: (id: string, body: TreasuryAccountPatch) =>
    request<TreasuryAccount>(`/api/v1/admin/treasury/${id}`, { method: "PATCH", body }),
};

export const marginCalls = {
  list: (action?: "CALL" | "STOP_OUT") =>
    request<MarginCall[]>(`/api/v1/admin/margin-calls${action ? `?action=${action}` : ""}`),
};
